var map = {
	"./afghanistan-large.jpg": 114,
	"./armenia-large.jpg": 115,
	"./azerbeidzan-large.jpg": 116,
	"./belarus-large.jpg": 117,
	"./georgia-large.jpg": 118,
	"./iraq-large.jpg": 119,
	"./kazakhstan-large.jpg": 120,
	"./kyrgyzstan-large.jpg": 121,
	"./moldova-large.jpg": 122,
	"./mongolia-large.jpg": 123,
	"./russia-large.jpg": 124,
	"./tajikistan-large.jpg": 125,
	"./turkmenistan-large.jpg": 126,
	"./ukraine-large.jpg": 127,
	"./uzbekistan-large.jpg": 128,
	"./worldwide-large.jpg": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;